export class Random {
  private x: number;
  private y: number;
  private z: number;
  private w: number; // seed
  constructor(seed: number) {
    this.x = 123456789;
    this.y = 362436069;
    this.z = 521288629;
    this.w = seed;
  }

  next(): number {
    const t = this.x ^ (this.x << 11);
    this.x = this.y = this.z = this.w;
    return (this.w = this.w ^ (this.w >>> 19) ^ (t ^ (t >>> 8)));
  }

  // min以上、max未満の正の整数を返す
  nextInt(min: number, max: number): number {
    return min + (Math.abs(this.next()) % (max - min));
  }

  static shuffle(random: Random, lists: Array<any>) {
    for( let i = lists.length - 1; i > 0; i-- ){
      const r = Math.floor(random.nextInt(0, i));
      const tmp = lists[i];
      lists[i] = lists[r];
      lists[r] = tmp;
    }
  }
}
